<template>
  <ol aria-label="Complete Sign-up Progress">
    <fragment v-for="(stepName, index) in stepNames" :key="index">
      <li
        class="step-container"
        :class="{ active: currentStep >= (index + 1) }"
        :aria-label="`Step 1: ${stepName}`"
        :aria-current="currentStep >= (index + 1) ? 'step' : false"
      >
        <div class="step-index-container">
          <span class="step-index" aria-hidden="true">{{ index + 1 }}</span>
        </div>
        <div class="step-name" aria-hidden="true">{{ stepName }}</div>
      </li>
      <li
        v-if="(index + 1) !== stepNames.length"
        class="spacer"
        :class="{ 'first-spacer': index === 0 }"
        aria-hidden="true">
      </li>
    </fragment>
  </ol>
</template>

<script>
export default {
  name: 'CompleteSignupProgress',
  props: {
    stepNames: {
      type: Array,
      required: true,
      validator (value) {
        return value.every(item => typeof item === 'string')
      }
    },
    currentStep: {
      type: Number,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
@mixin line {
  content: '';
  position: absolute;
  top: 9px;
  display: block;
  height: 2px;
  background-color: #CACAE1;
}

ol {
  display: flex;
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
}

.step-container {
  position: relative;
  text-align: center;

  &.active .step-index {
    background-color: $iconColorAccent;
  }

  &:not(:first-child)::before {
    @include line();
    left: 0;
    right: calc(50% + 25px);
  }

  &:not(:last-child)::after {
    @include line();
    right: 0;
    left: calc(50% + 25px);
  }
}

.spacer {
  position: relative;
  width: 100%;

  &::after {
    @include line();
    width: 100%;
  }

  &.first-spacer {
    width: 160%;
  }
}

.step-index {
  display: block;
  margin: 0 auto 8px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  color: white;
  font-size: 15px;
  line-height: 20px;
  background-color: $paginationBgColorBase;
}

.step-name {
  display: block;
  white-space: nowrap;
  font-size: 15px;
  font-weight: 400;
}
</style>
